// import Swiper JS
import Swiper, { Pagination } from 'swiper';
Swiper.use([Pagination]);

// import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

export default class Gallery {
    constructor() {
        document.addEventListener('DOMContentLoaded', () => {
            const galleryContainerAll = document.querySelectorAll<HTMLElement>('.custom-container-galerie');
            console.log(galleryContainerAll);

            if (galleryContainerAll.length) {
                galleryContainerAll.forEach($gallerySection => {
                    this.init($gallerySection);
                });
            }
        }, false);
    }

    init($gallerySection: HTMLElement) {
        const galleryId = $gallerySection.getAttribute('id');
        const imagesAll = $gallerySection.querySelectorAll<HTMLImageElement>('img');

        imagesAll.forEach($image => {
            // console.log($image.width, $image.height);
            if ($image.width > $image.height) {
                $image.style.height = '100%';
            } else {
                $image.style.width = '100%';
            }
        })
        // console.log($gallerySection.getAttribute('id'));
        new Swiper('#' + galleryId + ' .swiper', {
            spaceBetween: 32,
            autoHeight: false,
            slidesPerView: 1,
            centerInsufficientSlides: true,
            modules: [Pagination],
            centeredSlides: true,
            loop: true,
            pagination: {
                el: '#' + galleryId + ' .swiper-pagination',
                clickable: true
            },
            breakpoints: {
                640: {
                    slidesPerView: 2
                }
            }
        })
    }
}
